var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && _vm.url
    ? _c(
        "div",
        [
          _c(
            "clazy-load",
            { staticClass: "lazy-load", attrs: { src: _vm.url } },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _c("img", {
                  staticClass: "cursor-pointer",
                  attrs: { loading: "lazy", src: _vm.url },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onPreviewLegend(_vm.url)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: { slot: "placeholder", name: "fade" },
                  slot: "placeholder",
                },
                [
                  _c("div", { staticClass: "preloader" }, [
                    _c("div", { staticClass: "circle" }, [
                      _c("div", { staticClass: "circle-inner" }),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("VueEasyLightbox", {
            attrs: {
              visible: _vm.photos.visible,
              index: _vm.photos.index,
              imgs: _vm.photos.imgs,
              moveDisabled: false,
            },
            on: { hide: _vm.onClosePreviewLegend },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }